import { Box, Button, Grid, Tooltip, Typography, styled } from '@mui/material';
import React, { useEffect, useState } from 'react'

import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { StandardPanel } from '@websential/cosmic-v20'
import VisibilityIcon from "@mui/icons-material/Visibility";

interface ITD1PdfFileAdminForm {
    formMethods: any;
    pdfFileName: string;
    pdfSavedFile: any;
    onOpenFileClicked: () => void;
}
const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
});
const TD1PdfFileAdminForm: React.FC<ITD1PdfFileAdminForm> = ({
    formMethods,
    pdfFileName,
    pdfSavedFile,
    onOpenFileClicked,
}) => {
    const [fileName, setFileName] = useState<string>("");
    const [pdfSavedPdfFile, setPdfSavedFile] = useState(pdfSavedFile);
    useEffect(() => {
        setPdfSavedFile(pdfSavedFile);
        if (pdfSavedFile === false) {
            setFileName("Choose a file");
        }
    }, [pdfSavedFile]);
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            setFileName(file.name);
            setPdfSavedFile(false);
        }
    };
    return (
        <div style={{ marginTop: "4rem" }}>

            <StandardPanel
                title={'PDF File'} testId={"td1"}>
                <Grid
                    container
                    size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                    sx={{ alignItems: "center", pb: "3.1rem" }}
                >
                    <Grid size={{ xs: 12, sm: 12, md: 1, lg: 1, xl: 1 }}>
                        <Typography sx={{
                            color: "rgba(0,0,0,.6)",
                            fontSize: ".875rem",
                        }}>TD1 PDF File</Typography>
                    </Grid>
                    <Grid size={{ xs: 1, sm: .5, md: .5, lg: .5, xl: .5 }} sx={{ textAlign: "end" }}>
                        {pdfSavedPdfFile && (
                            <Tooltip title={"Open saved file."} placement={"top"}>
                                <VisibilityIcon
                                    sx={{
                                        fontSize: "1.1rem",
                                        margin: "7px 4px 4px 4px",
                                        cursor: "pointer",
                                    }}
                                    onClick={onOpenFileClicked}
                                />
                            </Tooltip>
                        )}
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 10.5, lg: 10.5, xl: 10.5 }}>
                        <Box sx={{ p: "12px" }}>
                            <Button
                                component="label"
                                role={undefined}
                                variant="contained"
                                tabIndex={-1}
                                startIcon={<CloudUploadIcon />}
                                sx={{ padding: "0px 7px 0px 10px", fontSize: "small" }}
                            >
                                Upload file
                                <VisuallyHiddenInput
                                    id="pdfFile"
                                    type="file"
                                    accept=".pdf"
                                    {...formMethods.register("pdfFile")}
                                    onChange={handleFileChange}
                                />
                            </Button>
                            <label
                                htmlFor="pdfFile"
                                style={{
                                    color: "rgba(0,0,0,.6)",
                                    cursor: "pointer",
                                    paddingLeft: "5px",
                                }}
                            >
                                {pdfSavedPdfFile && pdfFileName !== ""
                                    ? pdfFileName
                                    : fileName !== ""
                                        ? fileName
                                        : "Choose a file"}
                            </label>
                        </Box>
                    </Grid>
                </Grid>
            </StandardPanel>
        </div>
    )
}

export default TD1PdfFileAdminForm
